export default app => {
  // svg icon
  require('@/icons').default(app);
};
